import { inject, Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';

import { ApiService } from '@shared/services/api.service';
import { MainQuery } from '@shared/store/main/main.query';
import { OrganizationQuery } from '@shared/store/organization/organization.query';
import { TrialsQuery } from '@shared/store/trials/trials.query';

import { ChangeOrderState, ChangeOrderStore } from './change-order.store';

@Injectable({ providedIn: 'root' })
export class ChangeOrderQuery extends QueryEntity<ChangeOrderState> {
  private apiService = inject(ApiService);
  private mainQuery = inject(MainQuery);
  private organizationQuery = inject(OrganizationQuery);
  private trialQuery = inject(TrialsQuery);

  protected store: ChangeOrderStore;

  constructor() {
    const store = inject(ChangeOrderStore);

    super(store);

    this.store = store;
  }

  async downloadCO(
    id: string
  ): Promise<{ data: null | string; errors: string[]; success: boolean }> {
    const emptyReturn = {
      data: null,
      errors: ['Unexpected Error!'],
      success: false,
    };
    const co = this.getEntity(id);

    if (!co) {
      return emptyReturn;
    }

    const org = this.organizationQuery.getEntity(co.organization_id);

    if (!org) {
      return emptyReturn;
    }

    const currentTrial = this.mainQuery.getSelectedTrial();

    if (!currentTrial) {
      return emptyReturn;
    }

    const { data, errors, success } = await this.apiService.getS3ZipFile(
      this.getFilePath(co.organization_id, co.id)
    );

    if (success && data) {
      // [insert trial name]_[insert vendor name]_Change Order [insert Change Order #]_[insert date created YYYY.MM.DD]
      const fileName =
        `${currentTrial.short_name}_${org.name}_Change_Order_` +
        `${co.change_order_no}_${(co.create_date || '').slice(0, 10)}`;

      await this.apiService.downloadZipOrFile(data, fileName);
    }

    return { data, errors, success };
  }

  getFilePath(org_id: string, co_id: string) {
    const trial_id = this.mainQuery.getValue().trialKey;

    return `trials/${trial_id}/vendors/${org_id}/changeorders/${co_id}/`;
  }
}
